var map = {
	"./gallery_1.jpg": 7618,
	"./gallery_10.jpg": 2497,
	"./gallery_11.jpg": 1385,
	"./gallery_12.jpg": 861,
	"./gallery_13.jpg": 7778,
	"./gallery_14.jpg": 477,
	"./gallery_15.jpg": 5260,
	"./gallery_16.jpg": 7910,
	"./gallery_2.jpg": 4067,
	"./gallery_3.jpg": 1045,
	"./gallery_4.jpg": 3755,
	"./gallery_5.jpg": 8970,
	"./gallery_6.jpg": 7383,
	"./gallery_7.jpg": 817,
	"./gallery_8.jpg": 1720,
	"./gallery_9.jpg": 4424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6533;